import {
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
  WritableSignal,
} from '@angular/core';
import { DynamicContentsService } from '../../shared/services/dynamic-contents.service';
import { OpenPageModel, OpenPageService } from './services/open-page.service';

@Component({
  selector: 'app-menu-pages',
  templateUrl: './menu-pages.component.html',
  styleUrls: ['./menu-pages.component.scss'],
  standalone: false,
})
export class MenuPagesComponent implements OnInit {
  public readonly dynamicContentsService: DynamicContentsService = inject(DynamicContentsService);
  private readonly openPageService: OpenPageService = inject(OpenPageService);

  @Output() public readonly exit: EventEmitter<void> = new EventEmitter();

  public empSpecificContents: any;

  public openPage$: WritableSignal<OpenPageModel | undefined> = signal(undefined);

  ngOnInit() {
    this.getEmpSpecificContents();
  }

  public getEmpSpecificContents() {
    this.dynamicContentsService.getDynamicContents().subscribe(dynamicContents => {
      this.empSpecificContents = dynamicContents;
      this.openPageService.currentOpenPage.subscribe(openPage => {
        this.openPage$.set(openPage);
      });
    });
  }
}
